import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import { mobileMenuDropdownId } from '../utils/generalUtils';
import type { RenderVariant } from '../utils/typeUtils';

import { DropdownMenuLoggedIn } from './DropdownMenuLoggedIn';
import { DropdownMenuLoggedOut } from './DropdownMenuLoggedOut';

import * as styles from './DropdownMenu.css';

interface DropdownMenuProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const DropdownMenu = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: DropdownMenuProps) => {
  if (variant === 'logged-out') {
    return (
      <DropdownMenuContainer>
        <DropdownMenuLoggedOut baseUrl={baseUrl} />
      </DropdownMenuContainer>
    );
  }

  if (variant === 'logged-in-loading') {
    return null;
  }

  return (
    <DropdownMenuContainer>
      <DropdownMenuLoggedIn
        variant={variant}
        baseUrl={baseUrl}
        advertiserCentreUrl={advertiserCentreUrl}
      />
    </DropdownMenuContainer>
  );
};

interface DropdownMenuContainerProps {
  children: ReactNode;
}

const DropdownMenuContainer = ({ children }: DropdownMenuContainerProps) => (
  <Box
    id={mobileMenuDropdownId}
    className={styles.mobileDropdownMenu}
    data={{ testid: 'mobile-navigation-header-dropdown' }}
  >
    {children}
  </Box>
);
